import i18n from 'i18n';
import * as Yup from 'yup';

export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const DEFAULT_OPENS_AT = '09:00';
const DEFAULT_CLOSES_AT = '18:00';

export const getInitialOpeningHours = (openingHours) => {
  if (!Array.isArray(openingHours)) {
    return WEEKDAYS.map((_, weekday) => ({
      weekday,
      opens_at: weekday < 5 ? DEFAULT_OPENS_AT : '',
      closes_at: weekday < 5 ? DEFAULT_CLOSES_AT : '',
      is_closed: weekday >= 5,
    }));
  }

  const hoursByWeekday = new Map(openingHours.map((entry) => [entry.weekday, entry]));

  return WEEKDAYS.map((_, weekday) => {
    const entry = hoursByWeekday.get(weekday);
    if (!entry || entry.is_closed) {
      return {
        weekday,
        opens_at: '',
        closes_at: '',
        is_closed: true,
      };
    }

    return {
      weekday,
      opens_at: typeof entry.opens_at === 'string' ? entry.opens_at.slice(0, 5) : '',
      closes_at: typeof entry.closes_at === 'string' ? entry.closes_at.slice(0, 5) : '',
      is_closed: false,
    };
  });
};

export const buildOpeningHoursPayload = (openingHours) =>
  openingHours.map(({ weekday, opens_at, closes_at, is_closed }) => ({
    weekday,
    opens_at: is_closed ? null : `${opens_at.slice(0, 5)}:00`,
    closes_at: is_closed ? null : `${closes_at.slice(0, 5)}:00`,
    is_closed,
  }));

export const openingHoursValidationSchema = Yup.object({
  opening_hours: Yup.array()
    .length(7)
    .of(
      Yup.object({
        weekday: Yup.number().min(0).max(6).required(),
        is_closed: Yup.boolean().required(),
        opens_at: Yup.string().when('is_closed', {
          is: false,
          then: (schema) => schema.required(i18n.t('validation:required')),
        }),
        closes_at: Yup.string()
          .when('is_closed', {
            is: false,
            then: (schema) => schema.required(i18n.t('validation:required')),
          })
          .test(
            'after-opening-time',
            i18n.t('ownerPortal:locations.openingHours.closingTimeError'),
            function isAfterOpeningTime(value) {
              if (this.parent.is_closed || !value || !this.parent.opens_at) return true;
              return value > this.parent.opens_at;
            },
          ),
      }),
    ),
});
